import usePureState from '@/hooks/usePureState';
import IEventType from '@/types/IEventType';
import IHost from '@/types/IHost';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export interface ISectionCollaboratorArgs {
	service: IEventType;
	onChange: (values: Partial<IEventType>) => void;
}

interface IFormValues {
	email: string;
}

interface IState {
	hosts: IHost[];
}

export default function useSectionHosts(args: ISectionCollaboratorArgs) {
	const { t } = useTranslation();
	const { state, dispatch } = usePureState<IState>({
		hosts: args.service.hosts,
	});

	const { register, handleSubmit, formState } = useForm<IFormValues>({
		defaultValues: {
			email: '',
		},
	});

	async function onSubmit(values: IFormValues) {
		const newHost: IHost = {
			email: values.email,
			role: 'COLLABORATOR',
			calendars: [],
			// This id is used locally by React to identify the node
			id: Date.now().toString(),
			avatar: '',
			name: '',
		};
		return _update([...state.hosts, newHost]);
	}

	function handleRemove(email: string): void {
		const filteredHosts = state.hosts.filter((host) => host.email !== email);
		return _update(filteredHosts);
	}

	function _update(hosts: IHost[]) {
		args.onChange({ hosts });
		return dispatch({ hosts });
	}

	return {
		handleCollaboratorsSubmit: handleSubmit(onSubmit),
		handleRemove,
		register,
		t,
		formState,
		hosts: state.hosts,
	};
}
